import PropTypes from "prop-types";

export default PropTypes.shape({
  avatarUrl: PropTypes.string,
  fullName: PropTypes.string,
  companyName: PropTypes.string,
  isEmployer: PropTypes.bool,
  isRootParentEmployer: PropTypes.bool,
  isPartnerRecruiter: PropTypes.bool,
});
